<template>
  <button @click="onClick"
          :class="{
            'pp-ui-button': applyStyles,
            'pp-ui-hidden': !airplay.canCast,
            'pp-ui-enabled': airplay.casting
          }"
  >
    <slot>
      <AirPlay/>
    </slot>
  </button>
</template>

<script>
  import { PPComponentMixin } from '../mixins'
  import AirPlay from '../style/assets/airplay.svg'

  export default {
    name: "PPButtonAirPlay",
    components: {AirPlay},
    mixins: [PPComponentMixin],
    methods: {
      onClick() {
        this.airplay.showCastMenu()
      }
    }
  }
</script>
